import { createClient } from '@/src/lib/http/client/client';
import { CalculatePriceResponse } from '@/src/lib/product/types';
import { CalculatePriceRequestData } from '@/src/app/api/calculate-price/route';

export async function postCalculatePrice(request: CalculatePriceRequestData): Promise<CalculatePriceResponse> {
  const client = createClient();
  const response = await client.post('/calculate-price', {
    json: request,
  });

  return await client.handleResponse<CalculatePriceResponse>(response);
}
